import Status from 'clarks/components/ivu-table/status'

let forms = {
   filter_vouchers: {
      icon: 'fa fa-university',
      title: 'Search Account',
      subtitle: 'Provide Account Details',
      forms: [
         { type: "datepicker", form_type: "daterange", format: "dd-MM-yyyy", placement: "bottom-end", class: "col-md-6 col-lg-5 col-xl-4", validation: "required", placeholder: "Filter Voucher Cards by Date Created", model: "date", label: "Date",hide_label: true },
         { type: 'button', btnClass: 'btn-long btn-primary', class: 'col-md-3 col-lg-2', model: 'submit', label: 'Search'}
      ]
   },
}

let tables = {
   voucher_card: {
      props: {
         icon: 'fa fa-database',
         title: 'Voucher Cards',
         border: true,
         'max-height': 500,
         'show-summary': false,
         search_fields: ['email', 'names', 'amount','voucher_id','_id' ],
         columns: [
            { type: 'selection', width: 60, align: 'center' },
            { type: 'index', width: 60, align: 'center' },
            { title: "ID", slot: "id", minWidth: 250, align: 'center' },
            { title: "Names", key: "names", minWidth: 250 },
            { title: "Email", key: "email", minWidth: 250 },
            { title: "Amount", slot: "amount", width: 200, align: 'right' },
            { title: "Expires At", slot: "expires_at", width: 200, align: 'center' },
            { title: "Is Paid", slot: "is_paid", width: 200, align: 'center'  },
            { title: "Is Redeemed", slot: "is_redeemed", width: 200, align: 'center'  },
         ],
         actions: [
            { type: 'menu', title: 'View', event: 'view', allow_multiple: false }
         ]
      },
   },
}

export default {
   forms: utils.generateAllFormData(forms),
   tables
}